module.exports = __webpack_public_path__ + "media/images/protection-ee4a7d9c562862be46a24ec8f424468c.svg";